import React from 'react';
import './Develop.css';
import AnimatedContainer from '../AnimatedContainer/AnimatedContainer';
import { useNavigate } from 'react-router-dom';



const Develop = () => {
  const navigate = useNavigate();
  return (
    <div className="develop-container">
      <h1 className="develop-title">
        <span className='title-highlight'>Build</span> , <span className='title-highlight'>Launch</span> and  <span className='title-highlight'>Scale</span> with Skript
      </h1>
      <p className="develop-text">
      At Skript, we turn your ideas into fully-deployed, production-ready solutions with ease. From the first line of code to live deployment, we handle the entire process — ensuring speed, precision, and reliability. Whether it's web apps, mobile apps, or custom software, we deploy seamlessly to cloud platforms, tailored hosting, or your own infrastructure, giving you complete control and confidence at every stage of your project.
      </p>
      <AnimatedContainer/>
      <button className="develop-button"  onClick={() => window.open('/project_prompt', '_blank', 'noopener,noreferrer')}>
        Get Started
      </button>
    </div>
  );
};

export default Develop;
